__turbopack_context__.v({
  "chevron": "currencyFormat-module__iAMLha__chevron",
  "dropdown": "currencyFormat-module__iAMLha__dropdown",
  "item": "currencyFormat-module__iAMLha__item",
  "itemHighlighted": "currencyFormat-module__iAMLha__itemHighlighted",
  "list": "currencyFormat-module__iAMLha__list",
  "noResults": "currencyFormat-module__iAMLha__noResults",
  "open": "currencyFormat-module__iAMLha__open",
  "searchInput": "currencyFormat-module__iAMLha__searchInput",
  "searchableWrap": "currencyFormat-module__iAMLha__searchableWrap",
  "trigger": "currencyFormat-module__iAMLha__trigger",
  "triggerError": "currencyFormat-module__iAMLha__triggerError",
  "triggerPlaceholder": "currencyFormat-module__iAMLha__triggerPlaceholder",
});
